module.exports = __webpack_public_path__ + "img/logo.46e59d64.png";